import * as React from "react";
import {useState} from "react";
import cx from "classnames";
import Section from "../Layout/Section";
import Link from "../UI/Link";
import Media from "../Common/Media";
import TemplateString from "../Common/TemplateString";
import * as styles from "./opportunities.module.css";
import Arrow from "../../assets/svg/arrow.svg";

const OpportunityItem = ({title, description, functions}) => {
    const [activeFunction, setActiveFunction] = useState(0);

    return (
        <div className={styles.opportunities}>
            <div>
                <div>
                    <h3 className={styles.opportunities__title}>
                        <TemplateString template={title} />
                    </h3>
                    <p className={styles.opportunities__desc}>
                        <TemplateString template={description} />
                    </p>
                </div>
                {functions[activeFunction] && <Media media={{content: functions[activeFunction].image}} />}
            </div>
            <div>
                {functions.map(({id, title: itemTitle, url, description: itemDescription}, idx) => (
                    <div
                        key={id}
                        className={cx(styles.opportunities__item, {
                            [styles.opportunities__item_active]: activeFunction === idx,
                        })}
                    >
                        <h4 className={styles.opportunities__itemTitle}>
                            <span>
                                <TemplateString template={itemTitle} />
                            </span>
                            <Arrow />
                        </h4>
                        <div className={styles.opportunities__itemContent}>
                            <p className={styles.opportunities__itemDesc}>
                                <TemplateString template={itemDescription} />
                            </p>
                            {url && (
                                <Link className={styles.opportunities__itemLink} to={url} withArrow>
                                    Подробнее
                                </Link>
                            )}
                        </div>
                        <button
                            className={styles.opportunities__itemButton}
                            type="button"
                            onClick={() => setActiveFunction(idx)}
                            aria-label={`Открыть описание функции ${itemTitle}`}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

const Opportunities = ({title, opportunity}) => {
    return (
        <Section title={title}>
            {opportunity.map(({id, ...data}) => (
                <OpportunityItem key={id} {...data} />
            ))}
        </Section>
    );
};

export default Opportunities;
